import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { useAuthContext } from '@myphx-engineering/auth/client';
import { IconHome, SideNavLink } from '@myphx-engineering/phx-design-system';

import { useMaintenanceStatus } from '../../unauth-home/hooks/use-maintenance-status';
import { ConditionalComponent } from '../../utility/ConditionalComponent';
import { MenuSection } from '../MenuSection';

export const GettingStartedSection = () => {
    const { t } = useTranslation();
    const location = useLocation();
    const { disableAuthFlows, isAuthenticated, signUp } = useAuthContext();
    const { isMaintenanceActive } = useMaintenanceStatus();

    const register = useCallback(
        () => signUp(location.pathname),
        [signUp, location.pathname]
    );

    return (
        <ConditionalComponent condition={!isAuthenticated}>
            <MenuSection label={t('sidebar.gettingStarted.heading')}>
                <SideNavLink
                    disabled={isMaintenanceActive || disableAuthFlows}
                    label={t('sidebar.gettingStarted.createAccount')}
                    Icon={IconHome}
                    onClick={register}
                />
            </MenuSection>
        </ConditionalComponent>
    );
};
